
  (function () {
    document.addEventListener('click', function (e) {
      var trig = e.target.closest('[data-dyc-panel-trigger]');
      if (!trig) return;
      var panel = trig.closest('[data-dyc-panel]');
      var content = panel.querySelector('[data-dyc-panel-content]');
      if (!content.firstChild) {
        var src = document.querySelector(panel.dataset.dycSource);
        if (src) {
          // the accessories drawer carries swipe-to-snap touch listeners that
          // fight page scrolling once inline — a deep clone strips them (our own
          // document-level Add handler drives the items, so nothing is lost)
          if (panel.dataset.dycSource.indexOf('accessories') !== -1) {
            var clone = src.cloneNode(true);
            src.remove();
            src = clone;
          }
          src.classList.add('dyc-inline-embed', 'is-open', 'is-full');
          content.appendChild(src);
          // OEM parity: one-tap Add per upsell row
          src.querySelectorAll('.accessory-item').forEach(function (item) {
            var cb = item.querySelector('.accessory-item__checkbox');
            if (!cb || item.querySelector('.dyc-acc-add')) return;
            var btn = document.createElement('button');
            btn.type = 'button';
            btn.className = 'dyc-acc-add';
            btn.textContent = 'Add';
            btn.dataset.variant = cb.value;
            item.appendChild(btn);
          });
          (panel.dataset.dycHide || '').split(',').forEach(function (sel) {
            if (!sel) return;
            document.querySelectorAll(sel).forEach(function (n) { n.style.display = 'none'; });
          });
        }
      }
      var opening = panel.dataset.open !== 'true';
      panel.dataset.open = opening ? 'true' : 'false';
      if (opening) {
        setTimeout(function () {
          panel.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 370);
      }
    });

    // View Details: a fresh layer sliding over the panel content, in place
    document.addEventListener('click', function (e) {
      var trig = e.target.closest('.dyc-inline-embed [data-quick-view-trigger]');
      if (!trig) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      var panel = trig.closest('[data-dyc-panel]');
      var inner = panel.querySelector('.dyc-panel__inner');
      var layer = inner.querySelector('.dyc-panel__detail');
      if (!layer) {
        layer = document.createElement('div');
        layer.className = 'dyc-panel__detail';
        layer.innerHTML = '<button type="button" class="dyc-panel__detail-back">&lsaquo; Back</button>' +
          '<div class="dyc-panel__detail-body"></div>';
        layer.addEventListener('click', function (ev) {
          if (ev.target.closest('.dyc-panel__detail-back')) {
            layer.classList.remove('is-open');
            setTimeout(function () { layer.remove(); }, 320);
          }
        });
        inner.appendChild(layer);
      }
      var body = layer.querySelector('.dyc-panel__detail-body');
      body.innerHTML = '<p class="dyc-panel__detail-loading">Loading…</p>';
      requestAnimationFrame(function () { requestAnimationFrame(function () { layer.classList.add('is-open'); }); });
      var url = trig.getAttribute('data-product-url').split('?')[0];
      fetch(url + '.js').then(function (r) { return r.json(); }).then(function (prod) {
        var img = prod.featured_image ? '<span class="dyc-panel__detail-img"><img src="' + prod.featured_image + '" alt=""></span>' : '';
        body.innerHTML = img +
          '<b>' + prod.title + '</b>' +
          '<span class="dyc-panel__detail-tag">Included in every kit</span>' +
          '<div class="dyc-panel__detail-desc">' + (prod.description || '') + '</div>';
      }).catch(function () {
        body.innerHTML = '<p class="dyc-panel__detail-loading">Could not load details. Please try again.</p>';
      });
    }, true);

    // one-tap add per upsell row (OEM parity): add, flip to a check, refresh the
    // cart drawer quietly without opening it
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dyc-acc-add');
      if (!btn) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (btn.classList.contains('is-added')) return;
      btn.disabled = true;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(btn.dataset.variant, 10), quantity: 1 }] })
      }).then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        btn.disabled = false;
        btn.classList.add('is-added');
        btn.textContent = '✓ Added';
        return fetch('/cart.js').then(function (rr) { return rr.json(); }).then(function (cart) {
          document.querySelectorAll('.cart-count-bubble span, [data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
          var cd = document.querySelector('cart-drawer');
          if (cd && typeof cd._refreshSections === 'function') cd._refreshSections();
        });
      }).catch(function () { btn.disabled = false; });
    }, true);
  })();
